import { render, staticRenderFns } from "./PublicLayoutFooter.vue?vue&type=template&id=3186d803&scoped=true&"
import script from "./PublicLayoutFooter.vue?vue&type=script&lang=js&"
export * from "./PublicLayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./PublicLayoutFooter.vue?vue&type=style&index=0&id=3186d803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3186d803",
  null
  
)

export default component.exports